import React from 'react';

const NotFound = () => {
    return ( 
        <div className="not-found">
            <h1>Page Not Found</h1>
            <a href="/">
                Return to Homepage
            </a>
        </div>
     );
}
 
export default NotFound;